<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <!-- <div class="col-12">
              <div class="alert alert-primary" role="alert">اطلاعات شخصی</div>
            </div> -->
            <bita-select
              type="text"
              name="name"
              label="نوع"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              data-text-field="text"
              data-value-field="value"
              :data-source="[
                { value: 1, text: 'حقیقی' },
                { value: 2, text: 'حقوقی' },
              ]"
              v-model="dataForm.type"
            />
            <bita-input
              type="text"
              name="name"
              :label="dataForm.type == 1 ? 'نام' : 'نام شرکت'"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.name"
            />
            <bita-input
              v-if="dataForm.type == 1"
              type="text"
              name="family"
              label="نام خانوادگی"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.family"
            />
            <bita-input
              type="number"
              name="national_code"
              :label="dataForm.type == 1 ? 'کد ملی' : 'شناسه ملی'"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.national_code"
            />
            <bita-input
              type="text"
              name="phone"
              label="شماره تماس"
              rules="required|digits:11"
              place-holder="09134230000 یا 03534234323"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.phone"
            />
            <bita-input
              type="postal_code"
              name="postal_code"
              label="کد پستی"
              rules="required|digits:10"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.postal_code"
            />
            <bita-select
              name="state"
              label="استان"
              ref="stateDropDown"
              rules="required"
              validation-container-class="col-lg-6 col-md-6 col-sm-6"
              input-class="form-control"
              :data-source="state"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.state_id"
              @change="(e) => this.getCityOrgin(e)"
            />
            <Spinner
              :is-loading="isLoadingCities"
              class-name="col-lg-6 col-md-6 col-sm-6"
              styleName="align-self: center;"
            />
            <bita-select
              v-if="this.isLoadingCities === false"
              name="cities"
              label="شهر"
              ref="citiesDropDown"
              rules="required"
              validation-container-class="col-lg-6 col-md-6 col-sm-6"
              input-class="form-control"
              :data-source="cities"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.city_id"
            />
            <bita-textarea
              name="address"
              class="col-12"
              rules="required"
              inputClass="col-12 form-control"
              label="آدرس"
              v-model="dataForm.address"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <div class="d-flex flex-column flex-md-row justify-content-between">
        <div class="col-12 col-md-3 mb-2 mb-md-0">
          <bita-bootbutton
            v-if="!propsData.id"
            type="primary"
            title="ذخیره"
            icon="fa fa-check"
            class="w-100"
            @click.native="handleSubmit()"
          />
        </div>
        <div class="col-12 col-md-3">
          <bita-bootbutton
            v-if="propsData.id"
            type="primary"
            title="بروزرسانی"
            icon="fa fa-check"
            class="w-100"
            @click.native="handleSubmit()"
          />
          <div class="col-12 col-md-3 p-0">
            <bita-bootbutton
              class="w-100 text-danger bg-transparent border-0 text-center"
              type="danger"
              title="بستن"
              icon="fas fa-times"
              data-dismiss="modal"
              @click.native="
                () => {
                  $emit('change-status-modal');
                }
              "
            />
          </div>
        </div>
      </div>
    </div>
  </bita-modal>
</template>
<script>
import Spinner from "../../../components/Spinner";
export default {
  components: { Spinner },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    propsData: {
      type: Object,
      default: {
        id: 0,
        name: "",
        family: "",
        national_code: "",
        phone: "",
        postal_code: "",
        address: "",
        state_id: 0,
        city_id: 0,
      },
    },
    citiesData: { type: Array },
  },
  mounted() {
    this.getState();
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      dataForm: {
        type: 1,
      },
      isLoadingCities: false,
      state: [],
      cities: [],
    };
  },
  watch: {
    propsData: function(_data) {
      this.dataForm = _data;
    },
    citiesData: function(_data) {
      this.cities = _data;
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.dataForm);
        }
      });
    },
    getState() {
      this.$persistClient("get", "cities?filter[province]=0")
        .then((res) => {
          this.state = res.data;
        })
        .finally(() => {});
    },
    getCityOrgin(stateId) {
      this.isLoadingCities = true;
      this.$persistClient("get", `cities?filter[province]=${stateId}`)
        .then((res) => {
          this.cities = res.data;
        })
        .finally(() => {
          this.isLoadingCities = false;
        });
    },
    reset() {
      this.$refs.form.reset();

      this.dataForm = {
        type: 1,
      };

      this.$refs.citiesDropDown.emptyKendo();
      this.$refs.stateDropDown.emptyKendo();
    },
    onCloseModal(e) {
      this.reset();
    },
  },
};
</script>
